import { render } from "./z-team-modal.vue?vue&type=template&id=1c8e9cf7"
import script from "./z-team-modal.vue?vue&type=script&lang=js"
export * from "./z-team-modal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__